import React, { useEffect, useRef, useState } from "react";
import allApi from "../../../../api/allApi";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import errorIcon from "../../../../assets/images/error-2.png";
import Loader from "../../common/Loader";
import { useLocalization } from "../../localization/LocalizationContext";
import { asSwitchList, switchSerial } from "../../common/configValidation";

function CableTest() {
  const {localizationStrings} = useLocalization();
  const [deviceListing, setDeviceListing] = useState([]);
  const [serialNumber, setSerialNumber] = useState("");
  const [portId, setPortId] = useState([]);
  const [deviceResult, setDeviceResult] = useState([]);
  const [assignedPorts, setAssignedPorts] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const pollingRef = useRef(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showCableFailurePopup,setShowCableFailurePopup] = useState(false);
  const [loading,setLoading] = useState(false);

  useEffect(() => {
    getDeviceDetails();
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    };
  }, []);

  const getDeviceDetails = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/vlan/get/allSwitchBasicInfo");
      if (response) {
        setDeviceListing(asSwitchList(response));
      }
    } catch (error) {
      console.error("Error fetching devices", error);
    }
  };

  const cablePortTest = async () => {
    try {
      const api = new allApi();
      const portId = Object.keys(assignedPorts)
        .filter((key) => assignedPorts[key])
        .map(Number);
      const payload = {
        SerialNumber: serialNumber,
        portId: portId,
      };
      const response = await api.postRequest("api/vlan/cable-test", "", payload);
      if (response && response.uuid) {
        const uuid = response.uuid;
        startPolling(uuid);
        setShowPopup(false);
      }
    } catch (error) {
      console.error("Error in cable test", error);
    }
  };
  
  const startPolling = (uuid) => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
    }
  
    let elapsedTime = 0;
    let timeoutReached = false;
    setLoading(true);
  
    const interval = setInterval(async () => {
      elapsedTime += 1;
      if (elapsedTime >= 20) {
        timeoutReached = true;
      }
  
      const stopPolling = await getCableTestResult(uuid, timeoutReached);
  
      if (stopPolling || timeoutReached) {
        clearInterval(interval);
        pollingRef.current = null;
        setLoading(false);
      }
    }, 1000);
  
    pollingRef.current = interval;
  };
  
  const getCableTestResult = async (uuid, timeoutReached) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/vlan/cable/response/${uuid}`);
  
      if (response && response.response_data) {
        const parsedData = JSON.parse(response.response_data);
        setLoading(false);
        setDeviceResult(parsedData);
        setShowSuccessPopup(true);
        setAssignedPorts({});
        return true;
      } else if (timeoutReached && response && response.response_data == null) {
        setLoading(false);
        setShowCableFailurePopup(true);
        setAssignedPorts({});
        return true; // Stop polling since timeout has been reached
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error getting result", error);
      return false;
    }
  };
  

  const handleInputChange = (e) => {
    setSerialNumber(e.target.value);
  };

  const togglePort = (portNumber) => {
    setAssignedPorts((prev) => ({
      ...prev,
      [portNumber]: !prev[portNumber]
    }));
  };

  const handleCancel = () => {
    setSerialNumber("");
    setAssignedPorts({});
    setDeviceResult([]);
    setLoading(false);
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }
  const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return "Untested";
      case 1:
        return "Fail";
      case 2:
        return "Normal";
      case 3:
        return "Open";
      case 4:
        return "Short";
      case 5:
        return "Open Short";
      case 6:
        return "Cross Talk";
      case 7:
        return "No Cable";
      default:
        return "Unknown";
    }
  };

  const handleCancelPopUp = () => {
    setShowSuccessPopup(false);
  }

  const selectedDevice = deviceListing.find(
    (device) => switchSerial(device) === serialNumber
  );
  const isAnyPortSelected = Object.values(assignedPorts).some(Boolean);
  return (
    <div>
      <div className="tab-form">
        <div className="row mb-4">
          <div className="col-lg-12">
            <strong>
             {localizationStrings?.cableTestInfo}
            </strong>
            <div className="col-lg-6">
              <label htmlFor="modelName" className="col-form-label">
                {localizationStrings?.serialNumber}
              </label>
              <select
                className="form-select"
                name="modelName"
                value={serialNumber}
                onChange={handleInputChange}
              >
                <option value="">{localizationStrings?.selectSerialNumber}</option>
                {deviceListing.map((device, index) => (
                  <option key={index} value={switchSerial(device)}>
                    {switchSerial(device)}
                  </option>
                ))}
              </select>
            </div>

            {selectedDevice && (
              <>
                <p className="mt-4">{localizationStrings?.selectCablePort}</p>
                <div className="router-port left mt-3">
                  <div className="mxw-1260">
                    <div className="polygon"></div>
                    <div className="port-box">
                      <ul className={`port${selectedDevice.numberOfPorts}`}>
                        {[...Array(selectedDevice.numberOfPorts)].map((_, index) => {
                          const portNumber = index + 1;
                          return (
                            <li
                              key={portNumber}
                              className={
                                assignedPorts[portNumber] ? "assign" : "unassign"
                              }
                              onClick={() => togglePort(portNumber)}
                            >
                              {portNumber}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="tab-form">
        {loading && <Loader />}
          <div className="inc-card-table scrollable-result">
            <table>
              <thead>
                <tr>
                  <th>{localizationStrings?.port}</th>
                  <th>{localizationStrings?.testResult}</th>
                  <th>{localizationStrings?.faultDistance}</th>
                </tr>
              </thead>
              <tbody>
                {deviceResult && deviceResult.length > 0 ? (
                  deviceResult.map((port, index) => (
                    <tr key={index}>
                      <td>{port.portId || "N/A"}</td>
                      <td>{getStatusLabel(port.status)}</td>
                      <td>{port.cableFailureLen || "N/A"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3">{localizationStrings?.noData}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
      </div> 
      <div className="wifi-footer">
        <button type="button" className="btn btn-outline" onClick={handleCancel}>
          {localizationStrings?.cancel}
        </button>
        <button type="submit" className="text-btn primary-btn" onClick={() => setShowPopup(true)}
          disabled= {!(selectedDevice && isAnyPortSelected)}>
          {localizationStrings?.testSelectedPort}
        </button>
        {/* <button type="submit" className="text-btn primary-btn">
          {localizationStrings?.startAnotherTest}
        </button> */}
      </div>
      {showPopup && (
        <div className="customModal">
          <div className="c-modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{localizationStrings?.cableTest}</h5>
                <button type="button" className="btn-close" onClick={() => setShowPopup(false)}></button>
              </div>
              <div className="modal-body">
                <p>{localizationStrings?.cableDistruptInfo}
                 {localizationStrings?.cableInternetInfo}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline" onClick={() => setShowPopup(false)}>{localizationStrings?.noTestInfo}</button>
                <button type="submit" className="text-btn primary-btn" onClick={cablePortTest}>{localizationStrings?.yesTestInfo}</button>
              </div>
            </div>
          </div>
        </div>
      )}
       {showCableFailurePopup && (
              <div className="customModal confirm-modal">
                <div className="modal-dialog modal-dialog-centered small">
                  <div className="modal-content inc-modal">
                    <div className="modal-body">
                      <img src={errorIcon} alt="error" />
                      <h3>{localizationStrings?.cableFailureInfo}</h3>
                      <div className="modal-footer">
                        <button className="text-btn primary-btn" onClick={() => setShowCableFailurePopup(false)}>{localizationStrings?.close}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
      <Modal
        show={showSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.cableSuccess}</p>
        <Button onClick={handleCancelPopUp}>
          {localizationStrings?.ok}
        </Button>
      </Modal>
      

    </div>
  );
}

export default CableTest;